import type { CashierCashWithdrawal, CashTransferStatus } from '@/generated/graphql';

import { IAdmin, mapGQLAdmin } from './admin';
import { ICashier, mapGQLCashier } from './cashier';

export interface ICashierCashWithdrawal {
  id: string;
  amount: number;
  status: CashTransferStatus | string;
  createdAt: string;
  updatedAt: string;

  admin: IAdmin;
  cashier: ICashier;
}

export interface ICashierCashWithdrawalTable {
  id: string;
  amount: number;
  status: CashTransferStatus | string;
  createdAt: string;
  cashierUsername: string;
  adminUsername: string;
}

export interface ICashierCashWithdrawalQueryVariable {
  first: number;
  after?: string;
  before?: string;
}

export function mapGQLCashierCashWithdrawal(gql_cashierCashWithdrawal?: CashierCashWithdrawal | null): ICashierCashWithdrawal {
  return {
    id: gql_cashierCashWithdrawal?.id ?? '',
    amount: gql_cashierCashWithdrawal ? gql_cashierCashWithdrawal.amount ?? 0 : 0,
    status: gql_cashierCashWithdrawal ? gql_cashierCashWithdrawal.status ?? '' : '',

    updatedAt: gql_cashierCashWithdrawal ? gql_cashierCashWithdrawal.updatedAt ?? new Date().toISOString() : new Date().toISOString(),
    admin: mapGQLAdmin(gql_cashierCashWithdrawal?.admin),
    cashier: mapGQLCashier(gql_cashierCashWithdrawal?.cashier),
    createdAt: gql_cashierCashWithdrawal
      ? new Date(gql_cashierCashWithdrawal.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',
  };
}
